import * as React from "react";
import { Grid, Typography, Select, MenuItem, Box } from "@mui/material";
import { getHeaders } from "../utils/HeaderHelper";
import FlashMessage from "../shared/FlashMessage";
import { AuthenticationContext } from "../Context";
import { useFlash } from "../FlashContext";

interface Props {
  placeOfServiceList: any[];
  placeOfService: any;
  organizationId: any;
  setPlaceOfService: any;
  setSelectedOrganization: any;
}

const OrganizationPlaceOfService: React.FC<Props> = ({
  placeOfServiceList,
  placeOfService,
  organizationId,
  setPlaceOfService,
  setSelectedOrganization,
}) => {
  const authenticationSetting = React.useContext(AuthenticationContext);

  const { showToast } = useFlash();

  const handlePlaceOfServiceSave = async (event) => {
    setPlaceOfService(event.target.value);
    const value = event.target.value;

    if (value !== "Select Place of Service") {
      updateOrganization(value);
    }
  };

  const updateOrganization = (value) => {
    fetch(`/data_fetching/customers/${organizationId}`, {
      method: "PUT",
      headers: getHeaders(authenticationSetting?.csrfToken),
      body: JSON.stringify({
        customer: {
          place_of_service_code: value,
        },
      }),
    })
      .then((result) => result.json())
      .then((result) => {
        if (result.success) {
          setSelectedOrganization((prevOrg) => ({
            ...prevOrg,
            place_of_service_code: value,
          }));
          showToast({ title: "Place of Service Code Updated", text: "Place of Service Code Updated Successfully", type: "success" });
        } else {
          showToast({ title: "Update Failed", text: "Failed to update Place of Service Code", type: "error" });
        }
      })
      .catch((error) => {
        showToast({ title: "Update Failed", text: "Something went wrong", type: "error" });
      });
  };

  return (
    <Grid item xs={12} className="info-container">
      <div className="overview-container row">
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: "18px",
            letterSpacing: "1px",
            color: "#4A4442",
          }}
        >
          Place of Service
        </Typography>
      </div>

      <div className="divider" style={{ margin: "20px 0px 10px 0px" }}></div>

      <Typography
        sx={{
          fontSize: "12px",
          lineHeight: "18px",
          fontWeight: 700,
          marginBottom: "20px",
        }}
      >
        You can update the place of service of an organization to automatically
        apply to encounters and charge lines for claims but it is not required.
      </Typography>

      <Box className="field-container" sx={{ marginLeft: "0px" }}>
        <Select
          id="place-of-service"
          value={placeOfService || "Select Place of Service"}
          required
          variant="outlined"
          className="the-field"
          sx={{
            width: "55% !important",
            backgroundColor: "#EFE9E7 !important",
          }}
          onChange={handlePlaceOfServiceSave}
        >
          <MenuItem value="Select Place of Service" disabled>
            Select Place of Service
          </MenuItem>
          {placeOfServiceList?.map((option) => (
            <MenuItem
              key={option.code}
              value={`${option.code} - ${option.name}`}
            >
              {`${option.code} - ${option.name}`}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Grid>
  );
};

export default OrganizationPlaceOfService;
